import 'babel-polyfill'; // See https://babeljs.io/docs/en/babel-polyfill/

import React from 'react';
import DOM from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import createStore from '../app/store/create';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import routes from './routes/bunnings';
import { renderRoutes } from 'react-router-config';
import { AppContainer } from 'react-hot-loader';
import decorateHistoryWithAnalytics from '../app/utils/googleAnalytics';
import scroll from 'smoothscroll-polyfill';
scroll.polyfill();

const basename = window.env !== 'production' ? '/bunnings' : '/';

const history = createHistory({
  basename
});
const browserHistory = decorateHistoryWithAnalytics(history);
const initialState = window.__INITIAL_STATE__ ? JSON.parse(window.__INITIAL_STATE__) : {};
export const store = createStore(initialState, browserHistory);

const render = routes =>
  DOM.hydrate(
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>{renderRoutes(routes)}</ConnectedRouter>
      </Provider>
    </AppContainer>,
    document.getElementById('root')
  );

if (!Object.assign || !Object.keys || !Object.entries) {
  require.ensure(
    ['core-js/shim'],
    require => {
      require("core-js/shim"); // eslint-disable-line
      render(routes);
    },
    'opus-poly'
  );
} else {
  render(routes);
}

if (module.hot) {
  module.hot.accept('./routes/bunnings.js', () => {
    const nextRoutes = require('./routes/bunnings').default;
    render(nextRoutes);
  });
}
